import React from 'react';
import { observer } from 'mobx-react';
import { Theme, Modal, Paper, Typography, Button } from '@mui/material';
import { createStyles, WithStyles, withStyles } from '@mui/styles';
import { WithTranslation, withTranslation } from 'react-i18next';

import { WizardModel } from '../../models/kiosk/WizardModel';
import { Billpay } from '../../models/kiosk/Billpay';
import { ModalProps } from '@mui/material/Modal';
import { ButtonProps } from '@mui/material/Button';
import { defaultStyle } from './CommonModalStyles';

type ModalWithoutChildrenProps = Omit<ModalProps, 'children'>;

interface CloseWarningModalProps
    extends WithStyles<typeof styles>,
        WithTranslation {
    modalProps?: ModalWithoutChildrenProps;
    buttonProps?: ButtonProps;
}
interface CloseWarningModalPropsInjected extends CloseWarningModalProps {
    wizard: WizardModel;
    billpay: Billpay;
}

const styles = (theme: Theme) =>
    createStyles(defaultStyle);

@observer
class CloseWarningModal extends React.Component<CloseWarningModalProps, any> {
    get injected() {
        return this.props as CloseWarningModalPropsInjected;
    }

    render() {
        const { modalProps, buttonProps, classes, t } = this.props;

        return (
            <Modal
                aria-labelledby='close-warning-title'
                aria-describedby='close-warning-description'
                open={false}
                {...modalProps}
            >
                <Paper className={classes.root}>
                    <div className={classes.header}>
                        <Typography variant='h3'>{t('Warning')}</Typography>
                    </div>
                    <div className={classes.body}>
                        <Typography
                            variant='h4'
                            style={{ fontWeight: 'normal' }}
                        >
                            {t('You need to complete transaction first')}
                        </Typography>
                    </div>

                    <div className={classes.footer}>
                        <Button variant='primary' {...buttonProps}>
                            <Typography variant='button'>
                                {t('I understand')}
                            </Typography>
                        </Button>
                    </div>
                </Paper>
            </Modal>
        );
    }
}

export default withTranslation()(withStyles(styles)(CloseWarningModal));
